import PubSub from 'underpub-js';
import gsap from 'gsap';

var NavigationPopupItem = function (options) {
  this.options = {
    $el: false,
    baseClass: 'atom-NavigationPopupItem',
    isToggled: false,
  };

  $.extend(true, this.options, options);
};

NavigationPopupItem.prototype.init = function () {
  var self = this;

  self.$toggle = self.options.$el.find(
    `.${self.options.baseClass}__toggle`,
  );
  self.$items = self.options.$el.find(`.${self.options.baseClass}__items`);
  self.$toggleIcon = self.options.$el.find(
    `.${self.options.baseClass}__toggle__icon`,
  );
  self.$toggleIconLine = self.$toggleIcon.find('.line');
  self.$toggleIconLineHorizontal = self.$toggleIconLine.filter('.horizontal');
  self.$toggleIconLineVertical = self.$toggleIconLine.filter('.vertical');

  if (self.$items.length && self.$toggle.length) {
    self.initAnimation();
    self.$toggle.on('click', () => self.toggle());
  }

  PubSub.subscribe('NavigationPopupItem__toggleOff', () => self.toggleOff(100));
};

NavigationPopupItem.prototype.initAnimation = function () {
  const self = this;

  const getHeightTween = () =>
    gsap.to(self.$items, {
      height: self.options.isToggled ? 0 : 'auto',
      duration: 0.3,
      ease: 'expo.inout',
    });

  self.timeline = gsap
    .timeline({
      paused: true,
      reversed: true,
      onComplete: () => self.toggleState(),
      onReverseComplete: () => self.toggleState(),
    })
    .to(self.$toggleIconLineVertical, {
      rotation: 0,
      duration: .3,
      ease: 'expo.inout',
    })
    .to(
      self.$toggleIconLineHorizontal, {
        opacity: 0,
        rotation: 90,
        duration: .3,
        ease: 'expo.inout',
      },
      '<',
    )
    .call(getHeightTween, null, "<.2")
    .fromTo(
      self.$items, {
        opacity: 0,
      }, {
        opacity: 1,
        duration: 0.3,
        ease: 'expo.inout',
      },
      '<.1',
    );
};

NavigationPopupItem.prototype.toggleState = function () {
  const self = this;

  self.options.isToggled = !self.options.isToggled;
};

NavigationPopupItem.prototype.toggleOn = function (speed = 1) {
  const self = this;

  // Close any other open navigation item first
  PubSub.publish("NavigationPopupItem__toggleOff");

  if (self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).play();
};

NavigationPopupItem.prototype.toggleOff = function (speed = 3) {
  const self = this;

  if (!self.options.isToggled || self.timeline.isActive()) return;

  self.timeline.timeScale(speed).reverse();
};

NavigationPopupItem.prototype.toggle = function () {
  const self = this;

  self.timeline.reversed() ? self.toggleOn() : self.toggleOff();
};

export default NavigationPopupItem;